import React from "react";

type ContextStruct = {
  autoTranslate?: boolean;
  sourceLang?: string;
  targetLang?: string;
};

export const TranslationContext = React.createContext<ContextStruct>({});
